import { RegionSetFilter } from "@app/exports/exportModels";
import { NetworkAssessmentAnalysisType } from "@app/projects/enumerators";
import { QESCheckbox } from "@app/shared/qes-standards";
import { JSX } from "react";

interface SpecialtySummarySelectStatusFilterProps {
  disabled: boolean;
  onNetworkAssessmentAnalysisTypeChange: (networkAssessmentAnalysisType: NetworkAssessmentAnalysisType) => void;
  onSecondaryNetworkAssessmentAnalysisTypeChange?: (secondaryNetworkAssessmentAnalysisType: NetworkAssessmentAnalysisType) => void;
  regionSetFilter: RegionSetFilter;
  testIdSuffix: string;
}

export default function SpecialtySummarySelectStatusFilter(props: SpecialtySummarySelectStatusFilterProps): JSX.Element {
  return (
      <div className="col-12 mt0">
        <QESCheckbox
          label="Current Service Area"
          disabled={props.disabled}
          value="current"
          checked={props.regionSetFilter.networkAssessmentAnalysisType != null && props.regionSetFilter.networkAssessmentAnalysisType === NetworkAssessmentAnalysisType.ServiceArea}
          onChange={(e) => e.target.checked ? props.onNetworkAssessmentAnalysisTypeChange(NetworkAssessmentAnalysisType.ServiceArea) : props.onNetworkAssessmentAnalysisTypeChange(null)}
          testId={`select-status-filter__current-service-area--${props.testIdSuffix}`}
        />

        <QESCheckbox
          label="Opportunities to Expand"
          disabled={props.disabled}
          value="opportunity"
          checked={props.regionSetFilter.secondaryNetworkAssessmentAnalysisType != null && props.regionSetFilter.secondaryNetworkAssessmentAnalysisType === NetworkAssessmentAnalysisType.Opportunity}
          onChange={(e) => e.target.checked ? props.onSecondaryNetworkAssessmentAnalysisTypeChange(NetworkAssessmentAnalysisType.Opportunity) : props.onSecondaryNetworkAssessmentAnalysisTypeChange(null)}
          testId={`select-status-filter__opportunity--${props.testIdSuffix}`}
        />
      </div>
  );
}
